"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNavigationButton = exports.isNavigationAnchor = exports.highlightSubString = exports.IS_DEV = void 0;
var IS_DEV = process.env.NODE_ENV === "development";
/**
 * Find substring and wrap in <strong /> tag
 * @param {string} str - The string to search
 * @param {string} subString - The substring to find
 * @return {Obj} newStr - Object with text and match bool
 */

exports.IS_DEV = IS_DEV;

var highlightSubString = function highlightSubString(str, subString) {
  if (typeof str !== "string" || typeof subString !== "string") {
    return {
      text: str || "",
      match: false
    };
  }

  var caseInsensitiveRegex = new RegExp(subString, "gi");
  var newStr = str.replace(caseInsensitiveRegex, function (match) {
    return "<strong>".concat(match, "</strong>");
  });
  return {
    text: subString === "" ? str : newStr,
    match: newStr !== str
  };
};
/**
 * Whether a navigation item is an anchor.
 * @param link - The navigation item.
 */


exports.highlightSubString = highlightSubString;

var isNavigationAnchor = function isNavigationAnchor(link) {
  return !!link.url;
};
/**
 * Whether a navigation item is a button.
 * @param link - The navigation item.
 */


exports.isNavigationAnchor = isNavigationAnchor;

var isNavigationButton = function isNavigationButton(link) {
  return !link.url;
};

exports.isNavigationButton = isNavigationButton;